import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  CjThemeModule,
  CjSidebarModule,
  CjMenuModule,
  CjIconLibraries,
} from '@cashjar-dev/ui';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { JwtModule } from '@auth0/angular-jwt';
import { JwtHttpInterceptor } from '../../jwthttpinterceptor';
import { UtilityService } from './shared/services/utility.service';
import { VegaComponentModule } from '@heartlandone/vega-angular';

export function tokenGetter() {
  return localStorage.getItem('access_token');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot({
      timeOut: 15000,
      extendedTimeOut: 0,
      positionClass: 'toast-top-center',
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: tokenGetter,
      },
    }),
    CjThemeModule.forRoot(),
    CjSidebarModule.forRoot(),
    CjMenuModule.forRoot(),
    VegaComponentModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: JwtHttpInterceptor,
      multi: true,
    },
    UtilityService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(private iconLibraries: CjIconLibraries) {
    this.iconLibraries.registerFontPack('font-awesome-solid', {
      packClass: 'fas',
      iconClassPrefix: 'fa',
    });
    this.iconLibraries.registerFontPack('font-awesome-regular', {
      packClass: 'far',
      iconClassPrefix: 'fa',
    });
    this.iconLibraries.registerFontPack('font-awesome-brands', {
      packClass: 'fab',
      iconClassPrefix: 'fa',
    });
  }
}
